import { render, staticRenderFns } from "./UpdatePointContours.vue?vue&type=template&id=0d2c7e46&"
import script from "./UpdatePointContours.vue?vue&type=script&lang=js&"
export * from "./UpdatePointContours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports